<template>
    <a-modal
            :title="title"
            :width="640"
            :visible="visible"
            :confirmLoading="confirmLoading"
            okText="确定"
            cancelText="取消"
            @ok="handleSubmit"
            @cancel="handleCancel"
    >
        <a-spin :spinning="confirmLoading">
            <a-form :form="form">
                <a-form-item
                        label="名称"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{modalData.vendorName}}
                </a-form-item>
                <a-form-item
                        label="积分"
                        :labelCol="labelCol"
                        :wrapperCol="wrapperCol"
                >
                    {{modalData.point}}
                </a-form-item>
                <a-form-item v-if="formType === 'charge'"
                             label="充值积分"
                             :labelCol="labelCol"
                             :wrapperCol="wrapperCol"
                >
                    <a-input style="width: 70%" type="number" placeholder="输入充值的积分数量" v-decorator="['point', {rules: [{type: 'integer', required: true, min: 1, message: '充值的积分数量需为整数，且最小为1', transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
                <a-form-item v-else
                             label="扣减积分"
                             :labelCol="labelCol"
                             :wrapperCol="wrapperCol"
                >
                    <a-input style="width: 70%" type="number" placeholder="输入扣减的积分数量" v-decorator="['point', {rules: [{type: 'integer', required: true, min: 1, max: modalData.point,message: `扣减的积分数量需为整数，且最小为1，最多为` + modalData.point, transform: (value) => parseInt(value)}]}, ]" />
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script>
    export default {
        data () {
            return {
                // formModal统一数据
                visible: false,
                title: "",
                modalData: {},
                confirmLoading: false,
                form: this.$form.createForm(this),

                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 7 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 13 }
                },

                // 自定数据
                formType: ""
            }
        },
        methods: {
            showForm(modalData, type) {
                this.form.resetFields()
                this.visible = true
                this.modalData = modalData

                this.formType = type
                this.title = type === "charge"?"充值":"扣减"
            },

            handleSubmit () {
                const { form: { validateFields } } = this
                this.confirmLoading = true
                validateFields((errors, values) => {
                    if (!errors) {
                        setTimeout(() => {
                            this.visible = false
                            this.confirmLoading = false
                            values.id = this.modalData.id
                            this.$emit(this.formType === "charge"?'charge':"deduct", values)
                        }, 200)
                    } else {
                        this.confirmLoading = false
                    }
                })
            },
            handleCancel () {
                this.visible = false
            }
        },
    }
</script>
